module.exports = __webpack_public_path__ + "img/goods-accepted.55d6c770.svg";